// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.a23e543a3',
  revision: 'a23e543a3',
  branch: 'develop',
  date: 'Wed, 13 May 2026 11:15:17 GMT'
};